<template lang="pug">
  div
    el-row
      el-alert.tipo-documento(
        v-if="tipoDocumentoSelecionado && !mensagensIsEmpty()"
        :title="tipoDocumentoSelecionado.descricao",
        type="info")
        span.colorText {{mensagensTipoDocumento[tipoDocumentoSelecionado.codigo].texto}}
    el-row
      el-alert(
        v-if="invalidos.length > 0"
        title="Atenção",
        type="warning",
      )
          div(v-if='invalidos.length > 6' v-for='index in 6' :key='index')
            p.warning {{invalidos[index]}}
            p.warning(v-if='index === 6') E outros...
          div(v-if='invalidos.length <= 6' v-for='invalido in invalidos')
            p.warning {{invalido}}

    el-row(:gutter="20")
      el-col.container(:span="8")
        Label.sub-titulo(
          label="Tipo de documento:"
        )
        el-select.input(
          class="select",
          v-model="tipoDocumentoSelecionado",
          placeholder="Selecione",
          value-key="codigo",
          name="tipoDocumento",
          clearable
          filterable
          @change="tipoDocumentoOnChange",
        )
          el-option(
            v-for="item in tiposDocumentosFiltrados",
            :key="item.codigo",
            :label="item.descricao",
            :value="item"
          )
      el-col.container(:span="16")
        Label.sub-titulo(
          label="Anexar:"
        )
        div.upload-area(:id="id")
          transition(name="idle-fade")
            div.content.content-idle(v-if="!loading && !success" :class="{'error-upload' : errors.length}")
              .info(v-if='!documentos.length') Nenhum arquivo adicionado. Para adicionar um novo arquivo, selecione-o e clique no botão "Anexar".
              .info(v-else) Arraste e solte ou clique para selecionar um arquivo.
              .format Formatos suportados: {{ formatosSuportados }}
          transition(name="width-enter-active")
            el-row.content.content-loader(v-if="loading" :style="{width: (percentage < 20 ? 20 : percentage).toString() + '%'}")
              el-col.column(:span="12")
                div.name {{ fileName }}
                div.size {{ fileSize }} Kb
              transition(name="buttons-and-label-fade")
                el-col.column.right(v-if="success && percentage === 100")
                  div.label Carregado com sucesso!
          span.progress(v-if="!success && loading") {{ percentage }}%

        transition(name="buttons-and-label-fade")
          div.buttons(v-if="success")
            el-button(
              size="small"
              name="excluir"
              class="excluir"
              @click="excluir"
            )
              span.center
                i.fa.fa-times
                b &nbsp Remover
            el-button(
              size="small"
              name="anexar"
              class="anexar"
              @click="anexar"
              :disabled="!tipoDocumentoSelecionado"
              :title="!tipoDocumentoSelecionado ? 'Selecione o tipo de documento!' : ''"
            )
              span.center
                i.fal.fa-paperclip
                b &nbsp Anexar

        app-resumable(
          :ref="id",
          :target="target",
          :fileType="fileType",
          :idDrop="id",
          :idInput="id",
          :fileTypeErrorCallback="fileTypeErrorCallback"
          :maxSize="maxSize || null"
          @onSuccess="onSuccessEvent",
          @onError="onErrorEvent",
          @onProgress="onProgressEvent",
          @fileAdded="onFileAddedEvent"
        )
</template>

<script>
import { AppNotificacao, Label } from 'sicarf-components'
import AppResumable from '@/components/AppResumable'
import _ from 'lodash'
import { v4 as uuidv4 } from 'uuid'

export default {
  components: {
    AppResumable,
    Label
  },

  mixins: [
    AppNotificacao
  ],

  data () {
    return {
      style: null,
      success: false,
      loading: false,
      percentage: 0,
      fileName: '',
      fileSize: '',
      filee: null,
      documentoSelecionado: null,
      tipoDocumentoSelecionado: null,
      invalidos: []
    }
  },
  props: {
    required: {
      type: Boolean,
      default: true
    },

    tiposDocumentos: {
      type: Array,
      required: true
    },

    id: {
      type: String,
      required: true
    },

    target: {
      type: String,
      required: true
    },

    fileType: {
      type: Array,
      required: true
    },

    onSuccess: {
      type: Function,
      required: false,
      default: () => { }
    },

    onFileAdded: {
      type: Function,
      required: false,
      default: () => { }
    },

    onError: {
      type: Function,
      required: false,
      default: () => { }
    },

    onProgress: {
      type: Function,
      required: false,
      default: () => { }
    },

    documento: {
      type: Object,
      required: false
    },

    maxSize: {
      type: Number,
      required: false
    },

    errors: {
      required: false,
      type: Array,
      default: () => []
    },

    aba: {
      type: String,
      required: false
    },

    documentos: {
      required: false,
      type: Array,
      default: () => []
    },

    mensagensTipoDocumento: {
      type: Object
    }
  },

  mounted () {
    if (this.documento) {
      this.loading = true
      this.success = true
      this.fileName = this.documento.nomeOriginal
      this.fileSize = this.formatFileSize(this.documento.tamanho)
      this.percentage = 100
    }
  },

  computed: {
    formatosSuportados () {
      return this.fileType.join(', ')
    },

    // Joga a opção 'Outros' sempre para o fim de array
    tiposDocumentosFiltrados () {
      const array = [ ...this.tiposDocumentos ]

      if (array.length) {
        const index = _.findIndex(array, item => item.codigo.indexOf('OUTROS') === 0)

        array.splice(array.length, 0, array.splice(index, 1)[0])
      }

      return array
    }
  },

  methods: {
    formatFileSize (input) {
      return parseFloat((input / 1000).toFixed(2)).toLocaleString('pt-BR').toString()
    },
    clear () {
      this.loading = false
      this.success = false
      this.fileName = ''
      this.fileSize = ''
      this.percentage = 0
      this.documentoSelecionado = null
      this.tipoDocumentoSelecionado = null
    },

    excluir () {
      this.clear()
      this.$emit('removerDocumento', this.id)
    },

    async anexar () {
      const documento = Object.assign(this.documentoSelecionado, {
        ...this.documentoSelecionado,
        tipoDocumento: this.tipoDocumentoSelecionado
      })
      this.anexarDocumento(documento)
      this.clear()
    },

    anexarDocumento (documento) {
      this.$emit('anexar', documento)
    },

    fileTypeErrorCallback () {
      this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING,
        this.$messages.ARQUIVO_EXTENSION_FAIL.replace('$$', this.fileType.join(', ')))
    },

    onSuccessEvent (value, fileKey) {
      this.success = true
      this.$props.onSuccess(this.$props.id, value, fileKey)
      this.documentoSelecionado = {
        id: this.notID() ? null : uuidv4(),
        fileName: value.fileName,
        fileSize: value.fileSize,
        fileKey
      }
    },

    notID () {
      //! Função usada no análise pra remover o id colocado no anexo
      const removeIdAnexo = [
        'appUploadDocumento'
      ]
      return removeIdAnexo.includes(this.id)
    },

    onFileAddedEvent (file) {
      this.$refs[this.$props.id].uploadFile()
      this.loading = true
      this.fileName = file.file.name
      this.fileSize = this.formatFileSize(file.size)
      this.file = file
      this.$props.onFileAdded(this.$props.id, file)
    },

    onErrorEvent (message) {
      this.loading = false
      this.$props.onError(this.$props.id, message)
    },

    onProgressEvent (progress) {
      this.percentage = progress
      this.$props.onProgress(this.$props.id, progress)
    },

    mensagensIsEmpty () {
      return _.isEmpty(this.mensagensTipoDocumento)
    },

    tipoDocumentoOnChange (tipo) {
      this.$emit('tipoDocumentoChange', tipo)
    }
  },

  watch: {
    documento: {
      handler (val) {
        if (val && !val.removed) {
          this.loading = true
          this.success = true
          this.fileName = val.nomeOriginal
          this.fileSize = this.formatFileSize(val.tamanho)
          this.percentage = 100
        } else {
          this.clear()
        }
      },

      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/_variables.scss";

.input {
  width: 100%;
}

.upload-area {
  width: 100%;
  cursor: pointer;
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
}

.progress {
  align-self: center;
  color: $color-primary;
  padding: 0 10px;
}

.content {
  border-radius: 4px;
  width: 100%;
  height: 1rem;
  padding: 20px;
  margin-bottom: 0px;
}

.content-idle {
  background-color: $border-color;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .info {
    color: $font-dark-color;
    font-size: 0.9rem;
  }
  .format {
    padding-top: 0.25rem;
    font-size: 0.8rem;
  }
}

.content-loader {
  background-color: $color-primary;
  min-width: 50%;
}

.label,
.name {
  color: $white;
  font-size: 0.9rem;
}

.column {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.buttons {
  margin-top: 1rem;
  float: right;
}

.right {
  align-items: flex-end;
}

.label {
  font-weight: bold;
}

.size {
  color: $border-color;
  font-size: 0.9rem;
}

.excluir {
  color: $error;
}

.excluir:hover {
  background-color: #fef0f0;
  color: #f56c6c;
  border-color: #fbc4c4;
}

.width-enter-active {
  transition: width 1s;
}

.width-enter {
  width: 20%;
}

.idle-fade-enter-active {
  transition: opacity 1s;
}

.idle-fade-enter {
  opacity: 0;
}

.buttons-and-label-fade-leave-active {
  transition: opacity 0.2s;
}

.buttons-and-label-fade-leave-to {
  opacity: 0;
}

.buttons-and-label-fade-enter-active {
  transition: opacity 3s;
}

.buttons-and-label-fade-enter {
  opacity: 0;
}

.error-upload {
  border: 1px solid $error;
  border-radius: 13px;
}

.colorText {
  color: #606266 !important;
}

.sub-titulo {
  font-size: 14px;
  color: #606266 !important;
  font-weight:normal
}

.tipo-documento {
  color: #606266 !important;
  padding-left: 20px;
  padding-right: 20px;
  background-color: #f3f7fa;
  margin: 10px 0;
}

.warning {
  color: #e6a23c !important;
}

.content.content-idle {
  height: 0;
}
</style>
